// extracted by mini-css-extract-plugin
export var blockHeader = "ter-dakar-itinerary-search-block-module--blockHeader--d37dd";
export var title = "ter-dakar-itinerary-search-block-module--title--90306";
export var widgetWrapper = "ter-dakar-itinerary-search-block-module--widgetWrapper--f7c81";